import React, { useState } from "react"

import { NotificationManager } from "react-notifications"
import Select from "react-select"

import { PLAYBACK_RATE_OPTIONS } from "src/playbackRateOptions"

import { gql, useMutation } from "hooks/urql"

type Props = {
  studentId: string
  audioPlaybackRate: number
  disabled: boolean
}

const SetAudioPlaybackRate: React.FC<Props> = ({
  studentId,
  audioPlaybackRate,
  disabled,
}) => {
  const [, runMutation]: any[] = useMutation(updateRateMutation)
  const [selectedRate, setSelectedRate] = useState(audioPlaybackRate)

  const handleSubmit = (newRate: number) => {
    setSelectedRate(newRate)
    runMutation({
      studentId,
      audioPlaybackRate: newRate,
    })
      .then(result => {
        const { failures } = result.data.studentUpdateDefaultAudioPlaybackRate
        if (failures.length > 0) {
          setSelectedRate(audioPlaybackRate)
          NotificationManager.error(failures[0].message)
        } else {
          window.location.reload()
        }
      })
      .catch(() => {
        setSelectedRate(audioPlaybackRate)
        NotificationManager.error("Something went wrong")
      })
  }

  return (
    <div className="form-group w-[250px]">
      <Select
        options={PLAYBACK_RATE_OPTIONS}
        value={PLAYBACK_RATE_OPTIONS.find(opt => opt.value === selectedRate)}
        onChange={opt => handleSubmit(opt?.value)}
        menuPortalTarget={document.body}
        isDisabled={disabled}
      />
    </div>
  )
}

const updateRateMutation = gql`
  mutation studentUpdateDefaultAudioPlaybackRate(
    $studentId: ID!
    $audioPlaybackRate: Float!
  ) {
    studentUpdateDefaultAudioPlaybackRate(
      studentId: $studentId
      audioPlaybackRate: $audioPlaybackRate
    ) {
      student {
        id
        defaultAudioPlaybackRate
      }
      failures {
        message
      }
    }
  }
`

export default SetAudioPlaybackRate
